import {library} from '@fortawesome/fontawesome-svg-core';

import {
    faCoffee,
    faChild,
    faCircle,
    faArchive,
    faComment,
    faSignInAlt,
    faEyeSlash,
    faEye,
    faStepBackward,
    faStepForward,
    faBars,
    faUserFriends,
    faBookmark,
    faCalendarDay,
    faCalendarAlt,
    faHome,
    faAngleDown,
    faCogs,
    faChartArea,
    faEdit,
    faFileDownload,
    faFileUpload,
    faFile,
    faUndo,
    faPrint,
    faBook,
    faTimes,
    faSignOutAlt,
    faArrowsAltH,
    faWindowClose,
    faSave,
    faBan,
    faSearch,
    faPlus,
    faCheck,
    faHotel,
    faExchangeAlt,
    faTrash,
    faArrowRight,
    faExclamation,
    faUserPlus,
    faPaperclip,
    faComments,
    faCommentDots,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faTachometerAlt,
    faAsterisk,
    faMailBulk,
    faBell,
    faEnvelope,
    faUserTie,
    faSpinner,
    faFilter,
    faUpload,
    faUserTimes,
    faPlusCircle,
    faChevronCircleUp,
    faSync,
    faCheckCircle,
    faKey,
    faUserLock,
    faSyringe,
    faCircleNotch,
    faLocationArrow,
    faShip,
    faSquare,
    faThumbsUp,
    faThumbsDown,
    faEraser,
    faArrowUp,
    faArrowDown,
    faMinusCircle,
    faTimesCircle,
    faCog,
    faBackward,
    faArrowLeft,
    faWrench,
    faFolder,
    faUser,
    faChevronRight,
    faAnchor,
    faChevronDown,
    faArrowCircleUp,
    faLongArrowAltUp,
    faMinus,
    faPencilAlt,
    faMarker,
    faDatabase,
    faCheckDouble,
    faSortAmountUpAlt,
    faSortAmountDownAlt,
    faAlignJustify,
    faEllipsis,
    faAngleLeft,
    faAnglesLeft,
    faAngleRight,
    faAnglesRight,
    faPenToSquare,
    faListCheck,
    faCircleUser,
    faSheetPlastic,
    faFileLines,
    faFilePen,
    faScrewdriverWrench,
    faEllipsisVertical,
    faPen,
    faCirclePlay,
    faMusic,
    faFilePdf,
    faFileExcel,
    faFileWord,
    faImage,
    faCircleXmark,
    faArrowUpFromBracket,
    faClockRotateLeft,
    faSquarePen,
    faPaperPlane,
    faArrowRightFromBracket,
    faArrowRightToBracket,
    faSignature,
    faRotateLeft,
    faSquareArrowUpRight,
    faShare,
    faClone,
    faHand,
    faTriangleExclamation,
    faCircleInfo,
    faArrowPointer,
    faVideo, faFilm
} from '@fortawesome/free-solid-svg-icons';

import {
    faBell as faRegularBell, faPenToSquare as faRegularPenToSquare
} from '@fortawesome/free-regular-svg-icons'

export default () => {
    library.add(
        faCoffee, faChild, faCircle, faArchive, faComment, faSignInAlt, faEyeSlash, faEye,
        faStepBackward, faStepForward,
        faBars, faUserFriends, faBookmark, faCalendarDay, faCalendarAlt, faHome, faAngleDown,
        faCogs, faChartArea, faEdit, faBookmark, faFileDownload, faFileUpload, faFile, faUndo,
        faPrint, faBook, faTimes, faSignOutAlt, faArrowsAltH, faWindowClose, faArrowsAltH,
        faSave, faBan, faSearch, faPlus, faCheck, faHotel, faExchangeAlt, faTrash,
        faArrowRight, faExclamation, faComments, faCommentDots, faCaretDown, faCaretUp, faUserPlus,
        faPaperclip, faTachometerAlt, faAsterisk, faMailBulk, faBell, faEnvelope, faUserTie, faSpinner, faFilter,
        faUpload, faUserTimes, faPlusCircle, faChevronCircleUp, faSync, faCheckCircle, faKey,
        faUserLock, faSyringe, faCircleNotch, faLocationArrow,faShip,faSquare,faThumbsUp,faThumbsDown,faEraser,
        faArrowUp,faArrowDown,faMinusCircle,faTimesCircle, faCog, faBackward, faArrowLeft,faArrowCircleUp, faCaretRight,
        faWrench, faFolder,faUser, faChevronRight, faAnchor, faChevronDown,faLongArrowAltUp, faMinus,faPencilAlt,faMarker,
        faDatabase,faCheckDouble, faSortAmountUpAlt,faSortAmountDownAlt, faRotateLeft,
        faAlignJustify,faEllipsis, faAngleLeft,faAnglesLeft, faAngleRight,faAnglesRight, faPenToSquare, faListCheck, faCircleUser,
        faSheetPlastic, faFileLines, faFilePen, faScrewdriverWrench, faEllipsisVertical, faBan, faPen,
        faCirclePlay, faMusic, faFilePdf, faFileExcel, faFileWord, faFile, faImage, faCircleXmark, faArrowUpFromBracket, faClockRotateLeft,
        faRegularBell, faSquarePen, faRegularPenToSquare, faPaperPlane, faArrowRightFromBracket, faArrowRightToBracket, faCheckDouble,
        faSignature, faSquareArrowUpRight, faShare, faClone, faHand, faTriangleExclamation, faCircleInfo, faArrowPointer, faVideo, faFilm
    )
}